import axios from "axios";
import { Config } from "../Config";
import API from "./apiInstance";
import { userAccessToken } from "../helpers";

export const inviteUser = (account_id, location_id, data) => {
  return API.post(`/users/invitations/${account_id}/${location_id}`, data);
};
export const inviteUserNew = ( data) => {  
  return API.post(`/users/invitations_new`, data);
};

export const fetchUsersInvitations = (filter, account_id, location_id) => {
  const { page, per_page, search_term, order_by } = filter;
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  return API.get(
    `/users/invitation-listing?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const deleteInvitation = (id, location_id, account_id) => {
  return API.delete(
    `/users/invitation/${id}?location_id=${location_id}&account_id=${account_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const updateInvitedUser = (data) => {
  return API.put(`/users/invitations-update`, data, {
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: `Bearer ${userAccessToken()}`,
    },
  });
};

export const updateUser = async (data) => {
  data.default_location_id = data.default_location_id.toString();
  try {
    const response = await API.put(`/users/user_update`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addNewUser = async (data) => {
  try {
    const response = await API.post(`/users/create`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addNewUserWithoutToken = async (data) => {
  data.default_location_id = data.default_location_id.toString();
  try {
    const response = await API.post(`/users/create-user-without-token`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};



export const changePassword = (data) => {
  try {
    const response = axios.put(`${Config.apiServerUrl}/users/change_password`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) { }
};

export const requiredChangePassword = (data) => {
  try {
    const response = axios.put(`${Config.apiServerUrl}/users/require-change-password`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchAllUsers = (filter, account_id, location_id) => {
  const { page, per_page, search_term, order_by } = filter;
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  return API.get(
    `/users?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};


// export const getSpecialities = () => {
//   return API.get('/speciality/specialities', {
//     headers: {
//       "accept": "application/json",
//       Authorization: `Bearer ${userAccessToken()}`,
//     },
//   });
// };

export const getSpecialities = async () => {
  try {
    return await API.get('/speciality/all', {
      headers: {
        "accept": "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    
  } catch (error) {
    console.error("Error fetching specialities:", error.response?.status, error.response?.data?.detail || error.message);
  }
};


export const getPrescriberSpeciality = (prescriber) => {
  return API.get(`/speciality/prescriber_specialities/${prescriber}`, {
    headers: {
      "accept": "application/json",
      Authorization: `Bearer ${userAccessToken()}`,
    },
  });
}



export const getPrescribers = (account_id, location_id) => {
  return API.get(`/users/get_prescribers_list/${account_id}/${location_id}`, {
    headers: {
      "accept": "application/json",
      Authorization: `Bearer ${userAccessToken()}`,
    },
  });
};


export const deleteUser = (id, account_id, location_id) => {
  return API.delete(
    `/users/delete/${id}?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const onboardPractice = async (formData) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/onboarding-practice`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const onboardPracticev2 = async (formData) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/onboarding-practice-v2`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const setupOTP = (data) => {
  try {
    const response = axios.patch(`${Config.apiServerUrl}/users/otp_setup`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) { }
};

export const getOtpSettings = () => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/users/get_otp_setting`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) { }
};

export const setupScheduler = (data) => {
  // const valid_data = {"account_id":data.account_id, "global_enabled":data.global_enabled, "global_time":data.global_time};
  delete data.id;
  try {
    const response = axios.post(`${Config.notificationServerUrl}/message-transaction/config_schedule`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) { }
};

export const getScheduleSettings = (account_id) => {
  try {
    const response = axios.get(`${Config.notificationServerUrl}/message-transaction/get_schedule?account_id=${account_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) { }
};


export const updateScheduleSettings = (data) => {
  try {
    const response = axios.patch(`${Config.notificationServerUrl}/message-transaction/update_schedule?id=${data.id}`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) { }
};

export const forgotPassword = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/users/forgot_password`,data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const setNewPassword = (data, token) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/users/change_password?token=${token}`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      }
    );
    return response;
  } catch (error) { }
};

export const updateUserRole = async (data, account_id, location_id) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/users/update-role`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getOnboardPracticeData = async (props) => {
  const { location_id, account_id } = props;
  try {
    const response = axios.get(`${Config.apiServerUrl}/get-practice?account_id=${account_id}&location_id=${location_id}`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateOnboardPractice = async (formData) => {
  try {
    const { locations, practice_name, coding_price_type, charting_price_type, subscription_price, ...practiceData } = formData;

    const paymentData = {
      coding_price_type,
      charting_price_type,
      subscription_price
    };

    const updatedData = {
      "practice_data": practiceData,
      "location_data": locations,
      "payment_data": paymentData
    }

    const response = axios.put(`${Config.apiServerUrl}/update-practice`, updatedData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const portalFeatureConfigs = async (account_id) => {
  if (account_id === 0) {
    return false;
  }
  try {
    const response = axios.get(`${Config.apiServerUrl}/get-practice-feature-status?account_id=${account_id}`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getFeatureConfigsData = async () => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/get-feature-config`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateFeatureConfigsData = (props) => {
  const { account_id, updatedValues } = props;
  try {
    const response = axios.put(`${Config.apiServerUrl}/update-feature-config?account_id=${account_id}`, updatedValues,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const addFeatureConfig = (account_id, formData) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/create-feature-config?account_id=${account_id}`, formData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const getPracticePermissionData = async (account_id) => {
  var accountId = '';
  if(account_id){
    accountId = `?account_id=${account_id}`;
  }

  try {
    const response = axios.get(`${Config.apiServerUrl}/get-practice-permission${accountId}`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getAllPracticeData = async () => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/all/practice-and-location?show_id=true`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updatePracticePermissions = (updatedData) => {
  try {
    
    const response = axios.put(`${Config.apiServerUrl}/update-practice-permission?account_id=${updatedData?.account_id}`, updatedData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const getRolePermissionData = async (role_name) => {
  var roleName = '';
  if(role_name){
    roleName = `?role_name=${role_name}`;
  }

  try {
    const response = axios.get(`${Config.apiServerUrl}/get-role-permission${roleName}`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateUserRolePermissions = (updatedData) => {
  try {
    const response = axios.put(`${Config.apiServerUrl}/update-role-permission?account_id=${updatedData?.account_id}`, updatedData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchRoles = async () => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/users/get-roles`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const checkValidSlug = async (data) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/book-appointment/slug-validation`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};


export const createNewScheduler = (data) => {
  try {
    const response = axios.post(`${Config.notificationServerUrl}/schedulers/create-scheduler`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const loadAllSchedulers = (account_id, location_id) => {
  try {
    const response = axios.get(`${Config.notificationServerUrl}/schedulers/all-scheduler?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateSchedulerStatus = (data) => {
  try {
    const response = axios.put(`${Config.notificationServerUrl}/schedulers/change-scheduler-status`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteScheduler = (account_id, location_id, scheduler_id) => {
  try {
    const response = axios.delete(`${Config.notificationServerUrl}/schedulers/delete-scheduler-message?account_id=${account_id}&location_id=${location_id}&scheduler_id=${scheduler_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const resendScheduler = (data) => {
  try {
    const response = axios.post(`${Config.notificationServerUrl}/schedulers/send-now`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const setRoleExistPermissions = () => {
  try {
    const response = axios.get(`${Config.apiServerUrl}/update-permission-in-json-file`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchAllSpeciality = async () => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/speciality/all`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const fetchAllUserProviders = (account_id, location_id, specility_id = 32, speciality = false) => {
  let allSpeciality = speciality === true ? `&speciality_all=${speciality}` : "";
  try {
    const response = axios.get(`${Config.apiServerUrl}/users/providers?account_id=${account_id}&location_id=${location_id}&speciality_id=${specility_id}${allSpeciality}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
